import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AppErrorKeys } from '@timechef/core/errors/error';
import { I18nService } from '@timechef/core/i18n/i18n.service';

@Component({
  selector: 'app-error-container',
  templateUrl: './error-container.component.html',
  styleUrls: ['./error-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorContainerComponent implements OnChanges {
  @Input() errorKey?: string;
  @Input() icon = '';
  @Input() retryText = '';
  @Input() scope = 'ERRORS';

  @Input() forceText: string | null = null;

  @Output() retry = new EventEmitter<void>();

  translatedText?: string;

  constructor(private i18n: I18nService) {}

  ngOnChanges() {
    if (this.errorKey) {
      this.translatedText = this.i18n.translateError(this.errorKey, this.scope);
    } else if (this.forceText) {
      this.translatedText = this.forceText;
    } else {
      this.translatedText = this.i18n.translateError(AppErrorKeys.AnErrorOccured);
    }
  }
}
